import { VoyagePlan } from "../../../src/models/vessel-planning-model";
import { WeatherRoutingInfo } from "../../../src/models/voyage-routing-model";
import { formatDate } from "../../../src/utils/utils";

export const getWRStatusText = (weatherRoutingInfo: WeatherRoutingInfo) => {
    if (!weatherRoutingInfo.required) {
        return 'WR not required';
    }

    return 'WR required';
}

type StepState = 'completed' | 'current' | 'pending';

type WrStep = {
    label: string;
    state: StepState;
    tooltipText: string;
    timeStamp?: string;
};

export type WrProgressUiStatus = WrStep[];

export const getWrProgressStatus = (plan: VoyagePlan): WrProgressUiStatus => {
    const weatherRoutingInfo = plan.routes[plan.selectedRouteIndex]?.weatherRoutingInfo;

    if (!weatherRoutingInfo || !weatherRoutingInfo.required || !weatherRoutingInfo.requested_at) return [];

    const { requested_at, received_at, submitted_at, status } = weatherRoutingInfo;

    const steps: WrProgressUiStatus = [
        {
            label: 'Requested',
            state: requested_at ? 'completed' : 'pending',
            tooltipText: requested_at
                ? `The WR advice request has been initiated - ${formatDate(requested_at)}`
                : 'The WR advice request has not been initiated yet.',
            timeStamp: requested_at,
        },
        {
            label: 'Received by WNI',
            state:
                submitted_at && requested_at && submitted_at > requested_at
                    ? 'completed'
                    : 'pending',
            tooltipText: submitted_at && requested_at && submitted_at > requested_at 
                ? `The request has successfully reached WNI for processing - ${formatDate(submitted_at)}`
                : 'The request has not yet reached WNI.',
            timeStamp: submitted_at,
        },
        {
            label: "Advice Received",
            state:
                received_at && submitted_at && received_at > submitted_at && requested_at && received_at > requested_at
                        ? 'completed'
                        : 'pending',
            tooltipText: received_at && submitted_at && received_at > submitted_at && requested_at && received_at > requested_at
                ? `The WR advice has been received back from WNI ${formatDate(received_at)}`
                : 'Awaiting response from WNI.',
            timeStamp: received_at,
        },
        {
            label: "Accepted",
            state:
            (status === 'accept' || status === 'accept-notified') && received_at && requested_at && submitted_at && received_at > requested_at
                    ? 'completed'
                    : 'pending',
            tooltipText: (status === 'accept' || status === 'accept-notified') && received_at && requested_at && submitted_at && received_at > requested_at
                ? `The WR advice has been accepted`
                : 'The WR advice has not yet been accepted.',
        }
    ];

    return steps;
};